/*
* Form checkbox wrapper component
*/

import * as React from 'react';

export interface IFormCheckboxProps {
    checked?: boolean;
    disabled?: boolean;
}

export class FormCheckbox extends React.Component<IFormCheckboxProps, any> {
    public static defaultProps = {
        checked: false,
        disabled: true,
    };

    public static RenderCheckedBox(disabled: boolean = true) {
        return new FormCheckbox({ checked: true, disabled: disabled }).render();
    }

    public static RenderUncheckedBox(disabled: boolean = true) {
        return new FormCheckbox({ checked: false, disabled: disabled }).render();
    }

    public constructor(props: IFormCheckboxProps) {
        super(props);
    }

    public render() {
        return (<input type="checkbox" checked={this.props.checked} readOnly={this.props.disabled} disabled={this.props.disabled}  />);
    }
}



// WEBPACK FOOTER //
// ./src/common/formcheckbox.tsx